import DOMPurify from "dompurify";
import { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Dropdown from "@components/Dropdown/index";
import "./style.scss";
import pluseImg from "./img/pluse.svg";
import minusImg from "./img/minuse.svg";
import chevron from "./img/chevron.svg";
import { useQuery } from "@tanstack/react-query";
import { FAQ_CACHE_TIME, FAQ_STALE_TIME, getFaqList } from "../../../api/faq";
import { parseCMSBold } from "../../../Helpers";
import { useEffect } from "react";
import HeroDesktop from "./img/hero-desktop.png";
import HeroMobile from "./img/hero-mobile.jpg";

export default function FaqPage() {
  const [searchParams] = useSearchParams();
  const [currentQuestion, setCurrentQuestion] = useState({
    index: -1,
    open: false,
  });
  const [currentCategory, setCurrentCategory] = useState({
    index: -1,
    open: false,
  });

  const ident = searchParams.get("ident") || false;

  const faqQuery = useQuery({
    queryKey: ["faq-list"],
    queryFn: getFaqList,
    staleTime: FAQ_STALE_TIME,
    cacheTime: FAQ_CACHE_TIME,
  });

  const preparedFaq = useMemo(() => {
    if (faqQuery.data?.length !== 0) {
      const objectArray = [];

      faqQuery.data?.faqs?.forEach((element, index) => {
        if (
          objectArray.filter((e) => e.category === element.categoryName)
            .length === 0
        ) {
          objectArray.push({
            category: element.categoryName,
            content: [
              {
                title: element.content.title,
                answer:
                  element.content?.modules?.filter((e) => e.type === "intro")[0]
                    .custom || element.content.description,
                index: index,
                ident: element.ident,
              },
            ],
          });
        } else {
          objectArray[
            objectArray.findIndex((e) => e.category === element.categoryName)
          ].content.push({
            title: element.content.title,
            answer:
              element.content?.modules?.filter((e) => e.type === "intro")[0]
                .custom || element.content.description,
            index: index,
            ident: element.ident,
          });
        }
      });

      return objectArray || [];
    }
  }, [faqQuery.data]);

  useEffect(() => {
    if (ident) {
      const element = document.querySelector(`div#${ident}`);

      if (element) {
        const categoryIndex = parseInt(element?.dataset?.categoryindex);
        const questionIndex = parseInt(element?.dataset?.questionindex);

        setTimeout(() => {
          setCurrentCategory({
            index: categoryIndex,
            open: true,
          });

          setCurrentQuestion({
            index: questionIndex,
            open: true,
          });

          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 600);
      }
    }
  }, [ident, preparedFaq]);

  return (
    <div className="faq-page">
      <div className="page-grid">
        <div className="hero">
          <div className="image-wrapper">
            <picture>
              <source media="(min-width: 720px)" srcSet={HeroDesktop} />
              <img
                className="img"
                src={HeroMobile}
                alt={"Urządzenia i paczki neo/veo"}
              />
            </picture>
          </div>
          <div className="inner">
            <p className="desc">
              <strong>
                Die Antwort auf deine
                <br />
                wichtigste Frage finden
              </strong>
              <br />
              <span>
                Wenn du die Antwort nicht finden
                <br /> konntest, wende dich bitte an uns.
              </span>
            </p>
          </div>
        </div>

        <div className="faq-wrapper">
          {preparedFaq.map((element, categoryIndex) => (
            <Dropdown
              className="category"
              key={categoryIndex}
              open={
                currentCategory.index === categoryIndex && currentCategory.open
              }
              setOpen={() => {
                setCurrentCategory((prev) => ({
                  index: categoryIndex,
                  open: prev.index !== categoryIndex ? true : !prev.open,
                }));
              }}
              summary={
                <div className="category-wrapper">
                  <h2
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(parseCMSBold(element?.category)),
                    }}
                    className="category-title"
                  ></h2>
                  <img
                    className="dropdown-image"
                    alt="dropdown-image"
                    src={
                      currentCategory.index === categoryIndex &&
                      currentCategory.open
                        ? pluseImg
                        : minusImg
                    }
                  />
                </div>
              }
              details={
                <div className="faq-content">
                  {element?.content?.map((element, questionIndex) => (
                    <div key={questionIndex}>
                      <Dropdown
                        className="details"
                        key={element.index}
                        summary={
                          <div
                            className="question-wrapper"
                            id={element.ident}
                            data-categoryindex={categoryIndex}
                            data-questionindex={element.index}
                          >
                            <div className="question">
                              <h4
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(parseCMSBold(element?.title)),
                                }}
                              />

                              <img
                                alt="chevron"
                                src={chevron}
                                className={`chevron ${
                                  currentQuestion.index === element.index &&
                                  currentQuestion.open
                                    ? "chevron-rotated"
                                    : ""
                                }`}
                              />
                            </div>
                          </div>
                        }
                        details={
                          <div
                            className="answer"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(element?.answer),
                            }}
                          ></div>
                        }
                        open={
                          currentQuestion.index === element.index &&
                          currentQuestion.open
                        }
                        setOpen={() => {
                          setCurrentQuestion((prev) => ({
                            index: element.index,
                            open:
                              prev.index !== element.index ? true : !prev.open,
                          }));
                        }}
                      />
                      <div className="breakLine"></div>
                    </div>
                  ))}
                </div>
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
